import React, { useState, useCallback } from 'react';
import ZImage from 'sushiweb/ZImage';
import { Play } from 'sushiweb/Icons';
import './multimedia.scss';
import { Modal, ModalHeader } from '..';
import { VideoPlayer } from '../videoPlayer/videoPlayer';
import Carousel from 'sushiweb/Carousel';

const multimediaTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
};

const MultiMediaCarousel = (props) => {
  const { type, src } = props;
  return (
    <div className='tw-flex tw-justify-center tw-w-full tw-h-full'>
      {type.toLowerCase() === multimediaTypes.VIDEO && (
        <VideoPlayer
          src={src}
          css={`
            object-fit: contain;
          `}
        />
      )}
      {type.toLowerCase() === multimediaTypes.IMAGE && (
        <ZImage
          src={src}
          width='100%'
          height='100%'
          css={`
            img {
              width: 100%;
              max-height: 600px;
              object-fit: contain;
              object-position: center;
              border-radius: 6px;
            }
          `}
          alt='Sample image'
        />
      )}
    </div>
  );
};

export const MultiMediaV2 = ({ images, title }) => {
  const [ind, setInd] = useState(0);
  const [isOpen, toggleOpen] = useState(false);

  const handleClose = useCallback(() => toggleOpen(false), []);

  const handleClick = useCallback(
    (index) => () => {
      toggleOpen(true);
      setInd(index);
    },
    [],
  );

  if (images.length === 0) return null;

  return (
    <React.Fragment>
      {/* Selected images */}
      <div className='tw-flex tw-flex-col tw-grow-0 tw-rounded-[12px] tw-border-[0.5px] tw-border-solid tw-border-grey-300 '>
        <div className='tw-flex tw-justify-center tw-items-center tw-gap-4 tw-py-1 tw-px-0 tw-rounded-t-[12px] tw-bg-grey-100 tw-w-full'>
          <p
            className={`tw-text-100 tw-font-bold ${
              title === 'Product Image'
                ? 'tw-text-grey-700'
                : 'tw-text-orange-500'
            } `}
          >
            {title}
          </p>
        </div>
        {images[ind].type.toLowerCase() === multimediaTypes.VIDEO && (
          <video
            src={images[ind].src}
            className='tw-rounded-b-[12px] tw-cursor-pointer tw-m-auto tw-w-[164px] tw-h-[164px]'
            onClick={handleClick(ind)}
            controls
            muted
            alt='Sample video'
          />
        )}
        {images[ind].type.toLowerCase() === multimediaTypes.IMAGE && (
          <ZImage
            src={images[ind].src}
            width='164px'
            height='164px'
            onClick={handleClick(ind)}
            alt='Sample image'
            className='tw-rounded-b-[12px] tw-cursor-pointer'
          ></ZImage>
        )}
      </div>

      {/* Media Array */}
      <div className='tw-flex tw-items-start tw-gap-3 tw-flex-wrap tw-max-w-[170px]'>
        {images.map((image, index) => {
          return (
            <div
              key={index}
              className={`tw-flex tw-gap-8 ${
                index === ind ? 'activeMediaPreview' : 'inActiveMediaPreview'
              }`}
              css={`
                img,
                video {
                  padding: 0 !important;
                }
              `}
            >
              {image.type.toLowerCase() === multimediaTypes.VIDEO && (
                <div className='tw-relative'>
                  <video
                    src={image.src}
                    className='tw-w-[50px] tw-h-[50px]'
                    style={{
                      borderRadius: '0.6rem',
                      cursor: 'pointer',
                    }}
                    onClick={handleClick(index)}
                    alt='Sample video'
                    muted
                  />
                  <div
                    className='tw-absolute tw-bg-black tw-p-2 tw-pl-3 tw-rounded-full tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2'
                    onClick={handleClick(index)}
                  >
                    <Play size={15} color='rgb(224 224 224)' />
                  </div>
                </div>
              )}
              {image.type.toLowerCase() === multimediaTypes.IMAGE && (
                <ZImage
                  src={image.src}
                  width='50px'
                  height='50px'
                  onClick={handleClick(index)}
                  alt='Sample image'
                  imgAlt='Sample image'
                />
              )}
            </div>
          );
        })}
      </div>
      {isOpen && (
        <Modal
          isMaxContent
          maxHeight='82vh'
          isVisible={isOpen}
          type={'large'}
          containerStyles={{
            padding: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
          padding='0px'
          paddingTop={'0px'}
          component={
            <React.Fragment>
              <div className='tw-pl-5 tw-pt-5'>
                <ModalHeader title={title} handleClose={handleClose} />
              </div>
              <div className='tw-px-5 tw-pb-5 tw-overflow-auto'>
                <Carousel
                  showComponent={true}
                  componentData={images}
                  componentToRender={MultiMediaCarousel}
                  defaultTheme={false}
                  currentIndex={ind}
                  dots={images.length > 1 ? true : false}
                  infinite={images.length > 1 ? true : false}
                  width='100%'
                />
              </div>
            </React.Fragment>
          }
        />
      )}
    </React.Fragment>
  );
};
